// Export types
export type { ConflictType, ConflictResponse, RefetchOptions, MergeOptions, ConflictHandler } from './types';
export { isConflictResponse } from './types';

// Export registry
export { ConflictHandlerRegistry, conflictHandlerRegistry } from './registry';

// Export errors
export { ConflictError, NoConflictHandlerError, MaxRetriesExceededError } from './errors';

// Export logger
export { conflictLogger } from './logger';
export type { ConflictLogEntry, ConflictStats } from './logger';

// Import handlers
import { taskConflictHandler } from '../../stores/taskLists/conflictHandlers/taskConflictHandler';
import { taskListUnitConflictHandler } from '../../stores/taskLists/conflictHandlers/taskListUnitConflictHandler';
import { taskReportConflictHandler } from '../../stores/taskLists/conflictHandlers/taskReportConflictHandler';
import { conflictHandlerRegistry } from './registry';

/**
 * Register all conflict handlers.
 * Call this during application initialization to enable automatic conflict resolution.
 */
export function registerConflictHandlers(): void {
    console.log('[Conflict Resolution] Registering conflict handlers...');
    
    conflictHandlerRegistry.register(taskConflictHandler);
    conflictHandlerRegistry.register(taskListUnitConflictHandler);
    conflictHandlerRegistry.register(taskReportConflictHandler);
    
    const registeredTypes = conflictHandlerRegistry.getRegisteredTypes();
    console.log(`[Conflict Resolution] Registered handlers for: ${registeredTypes.join(', ')}`);
}
